export function findByCommunicationIdQuery(communicationId) {
  const query = `{findPlanHeaderByCommunicationId(communicationId: ${communicationId})
  {id, subject{id, name, active}, startDate, endDate, theme, generalObjective, contents, procedureTaken, resources, evaluation, generalObservation}}`;
  return query;
}

export function findByPlanHeaderIdQuery(planHeaderId) {
  const query = `{findBnccSkillsByPlanHeader(planHeader: {id: ${planHeaderId}})
  {bnccSkill{id, name, description}}}`;
  return query;
}
